var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var CountersModel = GenericModel.extend(
{
    urlRoot : "/rest/api/monitors",
id : null,
});

module.exports = CountersModel;